import { Component, effect, inject, Type, ChangeDetectionStrategy } from '@angular/core';
import { CuiDialogRef, DialogService } from '@idealink-material/ui-utils';
import { SessionStatus } from '@/core/model/session-status';
import { SessionMonitorService } from '@/core/service/session-monitor.service';
import { SessionDurationLocked } from '@/core/template/session-duration-locked';
import { SessionDurationExpired } from '@/core/template/session-duration-expired';
import { SessionDuplicate } from '@/core/template/session-duplicate';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

@Component({
    selector: 'app-dynamic-session-handler',
    template: ``,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class DynamicSessionHandler {
    private readonly dialogService = inject(DialogService);
    private storageService = inject(STORAGE_SERVICE_TOKEN);
    private dialogRef: CuiDialogRef<void> | null = null;

    constructor(private sessionMonitor: SessionMonitorService) {
        effect(() => {
            switch (this.sessionMonitor.sessionStatus()) {
                case SessionStatus.ReloginPrompt:
                    this.load(SessionDurationLocked);
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.ReloginPrompt);
                    break;
                case SessionStatus.LogoutPrompt:
                    this.load(SessionDurationExpired);
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.LogoutPrompt);
                    break;
                case SessionStatus.DuplicateSession:
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.DuplicateSession);
                    this.load(SessionDuplicate);
                    break;
                default:
                    break;
            }
        });
    }

    clear() {
        this.dialogRef?.close();
    }

    load(component: Type<any>): void {
        this.dialogRef?.close();
        // These are small, centered auth-flow modals — narrower than ui-core's 480px default.
        this.dialogRef = this.dialogService.open(component, { width: '350px', closeOnBackdropClick: false, closeOnEscape: false });
        this.dialogRef.closed$.subscribe(() => {
            this.dialogRef = null;
        });
    }
}
